// extracted by mini-css-extract-plugin
export default {"inputWrapper":"PhoneEmailInput_inputWrapper__jVCxB","errorMsg":"PhoneEmailInput_errorMsg__LZQ0t"};